// <head> metadata for TermsOfServicePage (https://www.dbos.dev/terms-of-service).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Terms of Service | DBOS',
    },
    {
      name: 'description',
      content:
        'The terms of service that govern your use of the DBOS website and the products and services of DBOS, Inc.',
    },
    {
      property: 'og:title',
      content: 'Terms of Service | DBOS',
    },
    {
      property: 'og:description',
      content:
        'The terms of service that govern your use of the DBOS website and the products and services of DBOS, Inc.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Terms of Service | DBOS',
    },
    {
      name: 'twitter:description',
      content:
        'The terms of service that govern your use of the DBOS website and the products and services of DBOS, Inc.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/terms-of-service',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
